import { InternshipDomain } from "../types";

export const DOMAINS_DATA: InternshipDomain[] = [
  {
    id: "full-stack-mern",
    shortSlug: "full-stack",
    title: "Full-Stack Web Development",
    subTitle: "Master the MERN Stack (MongoDB, Express.js, React, Node.js)",
    heroHeadline: "Become a Job-Ready",
    heroHighlight: "Full-Stack Web Developer",
    heroParagraph: "Accelerate your career in software engineering. Build live production-ready SaaS platforms, master database pipelines, and secure a place in top-tier tech companies through our hands-on talent development program.",
    duration: "12 to 24 Weeks",
    availability: "Onsite/Hybrid",
    heroImage: "https://images.unsplash.com/photo-1542831371-29b0f74f9713?auto=format&fit=crop&w=1200&q=80",
    stats: {
      studentsTrained: "4,450+",
      projectsCompleted: "840+",
      placementRate: "98.2%"
    },
    seoKeywords: [
      "MERN stack internship",
      "Full stack developer internship",
      "React JS online internship",
      "Node JS backend training",
      "Web development internship with certificate",
      "Hitasoft full stack internship",
      "full stack internship Tamil Nadu",
      "MERN stack training Madurai",
      "online internship Tamil Nadu",
      "internship for CSE students Tamil Nadu",
      "web development internship for college students",
      "internship with certificate Tamil Nadu"
    ],
    metaTitle: "MERN Full-Stack Developer Internship Tamil Nadu | Hitasoft Talent Lab Madurai",
    metaDescription: "Apply for the premium Full-Stack MERN internship. Master React, Node.js, Express, and MongoDB under industry experts. Build live projects with certificate.",
    careerOpportunities: [
      "MERN Stack Developer",
      "Frontend Engineer (React)",
      "Backend Node JS Specialist",
      "Software Engineer Associate",
      "Platform Development Engineer"
    ],
    outcomes: [
      "Design and develop full-stack applications using the MERN stack.",
      "Build secure APIs, authentication systems, and database-driven platforms.",
      "Implement advanced React concepts, state management, and performance optimization techniques.",
      "Deploy and manage applications in cloud-based production environments.",
      "Create industry-ready projects that showcase your capabilities to potential employers."
    ],
    technologies: [
      { name: "React.js", category: "Frontend Framework", desc: "Component-driven UI library with hooks & State", icon: "Layers" },
      { name: "Node.js", category: "Backend Runtime", desc: "High-performance asynchronous JavaScript engine", icon: "Cpu" },
      { name: "MongoDB", category: "Database Platform", desc: "NoSQL document store optimized for JSON-like storage", icon: "Database" },
      { name: "Express.js", category: "Web Framework", desc: "Minimalist backend framework for REST APIs", icon: "Terminal" },
      { name: "Next.js", category: "Modern SSR Framework", desc: "Server-side rendered React apps & SEO modules", icon: "Globe" },
      { name: "Redux Toolkit", category: "State Management", desc: "Scalable client state control frameworks", icon: "Activity" }
    ],
    projects: [
      {
        title: "OmniChannel E-Commerce SaaS",
        desc: "A headless online commerce store featuring live inventory updates, Stripe integration, nested category schema, and a supercharged admin analytics console.",
        tech: ["React.js", "Node.js", "MongoDB", "Redux Toolkit"],
        application: "Multi-vendor digital storefronts seeking sub-second load times",
        difficulty: "Advanced"
      },
      {
        title: "Real-Time Collaborative Workspace",
        desc: "A teamwork board with Kanban states, secure user chats via Socket.io, real-time shared canvases, and instant push notification modules.",
        tech: ["Next.js", "Express.js", "Node.js", "MongoDB"],
        application: "Project management software used internally by digital studios",
        difficulty: "Intermediate"
      }
    ],
    faqs: []
  },
  {
    id: "web-dev-php-python",
    shortSlug: "web-dev",
    title: "Web Development (PHP & Python)",
    subTitle: "Robust Enterprise Backend Architecture & MVC Frameworks",
    heroHeadline: "Build Secure, Scalable Core Backend Architectures as an",
    heroHighlight: "Enterprise Web Developer",
    heroParagraph: "Master robust backend development, relational database modeling, and fast secure APIs. Learn enterprise frameworks like Laravel (PHP) and Django (Python) that power top global applications.",
    duration: "8 to 16 Weeks",
    availability: "Onsite/Hybrid",
    heroImage: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=1200&q=80",
    stats: {
      studentsTrained: "9,120+",
      projectsCompleted: "620+",
      placementRate: "95.6%"
    },
    seoKeywords: [
      "PHP internship",
      "Python Django internship with certificate",
      "Backend web developer training",
      "Laravel web development course",
      "Relational databases MySQL internship",
      "Python developer training programs",
      "web development course Tamil Nadu",
      "PHP Python internship Madurai",
      "online web development internship Tamil Nadu",
      "internship for engineering students Tamil Nadu",
      "backend developer course with certificate"
    ],
    metaTitle: "PHP & Python Web Development Internship Tamil Nadu | Hitasoft Talent Lab Madurai",
    metaDescription: "Professional backend internship in PHP Laravel & Python Django. Master secure database structure, MVC architectures, and REST APIs with live projects.",
    careerOpportunities: [
      "Backend PHP Developer",
      "Python Django Software Engineer",
      "Laravel API Developer",
      "Database Administrator (MySQL/PostgreSQL)",
      "Systems Integrator Specialist"
    ],
    outcomes: [
      "Write object-oriented PHP and Python adhering to framework best-practices.",
      "Design advanced database schemas and handle migrations on MySQL and Postgres.",
      "Build secure corporate portals with custom middleware authentication and role access.",
      "Deconstruct complex API requirements to integrate payment gateways and email triggers."
    ],
    technologies: [
      { name: "Laravel", category: "PHP MVC Framework", desc: "Elegant syntax framework for modern PHP web applications", icon: "Layers" },
      { name: "Django", category: "Python Framework", desc: "High-level web engine facilitating clean, pragmatic design", icon: "Cpu" },
      { name: "MySQL / PostgreSQL", category: "Relational Database", desc: "Standard SQL-based structured transactional storage", icon: "Database" },
      { name: "Python Core", category: "Core Language", desc: "High-level versatile programming language used in web and data", icon: "Terminal" },
      { name: "PHP 8.x", category: "Core Language", desc: "Server-side language powering the majority of modern websites", icon: "Globe" },
      { name: "RESTful APIs", category: "API Design", desc: "Standard patterns for secure client-server communication", icon: "Activity" }
    ],
    projects: [
      {
        title: "Enterprise Inventory ERP System",
        desc: "A highly resilient logistics manager tool to handle warehouses, calculate real-time VAT taxes, manage product SKUs, and automatically generate PDF invoices.",
        tech: ["PHP 8.x", "Laravel", "MySQL", "Tailwind CSS"],
        application: "Production systems connecting inventory trackers across multiple cities",
        difficulty: "Advanced"
      },
      {
        title: "RESTful Content Management Engine",
        desc: "A headless CMS providing lightning-fast API queries, search filters, post scheduling, and custom role-based privileges for editors.",
        tech: ["Python", "Django", "PostgreSQL", "Docker"],
        application: "Digital media networks storing hundreds of thousands of blog items",
        difficulty: "Intermediate"
      }
    ],
    faqs: [
      {
        question: "Can I choose to focus on Laravel or Django exclusively during this internship?",
        answer: "Yes, you can specialize in either the PHP/Laravel track or the Python/Django stack. Our expert counselors will guide you toward the best fit matching your career goals."
      },
      {
        question: "Are database management and storage systems covered?",
        answer: "Absolutely. Relational database design, query optimization, foreign key relationships, indexing, and transactional integrity form a core component of this backend program."
      }
    ]
  },
  {
    id: "ml-ai",
    shortSlug: "ml-ai",
    title: "Machine Learning & AI",
    subTitle: "Artificial Intelligence, Deep Learning & LLM Integrations",
    heroHeadline: "Architect Intelligent Intelligent Predictive Models as an",
    heroHighlight: "AI & Machine Learning Engineer",
    heroParagraph: "Enter the world of smart computation. Implement complex deep-learning layers, train predictive algorithms on big data pipelines, and integrate generative LLMs into standard business workflows.",
    duration: "12 to 24 Weeks",
    availability: "Onsite/Hybrid",
    heroImage: "https://images.unsplash.com/photo-1677442136019-21780efad99a?auto=format&fit=crop&w=1200&q=80",
    stats: {
      studentsTrained: "7,800+",
      projectsCompleted: "550+",
      placementRate: "97.4%"
    },
    seoKeywords: [
      "Machine learning internship",
      "Artificial Intelligence training course",
      "Python AI developer internship",
      "TensorFlow deep learning project",
      "Generative AI LangChain program",
      "Hitasoft AI research lab",
      "machine learning internship Tamil Nadu",
      "AI internship for students Tamil Nadu",
      "data science AI course Madurai",
      "online AI internship with certificate",
      "engineering internship Tamil Nadu ML"
    ],
    metaTitle: "Machine Learning & AI Internship Tamil Nadu | Hitasoft Talent Lab Madurai",
    metaDescription: "Acquire hands-on expertise in TensorFlow, PyTorch, Predictive Modeling, and Generative Artificial Intelligence. Work with certified AI researchers.",
    careerOpportunities: [
      "Machine Learning Engineer",
      "Computer Vision Specialist",
      "Generative AI developer",
      "NLP Algorithms Engineer",
      "Research Scientist Assistant"
    ],
    outcomes: [
      "Preprocess large tabular, text, and visual datasets using Pandas and Numpy.",
      "Train ML estimators including XGBoost, Random Forests, and SVMs with sci-kit-learn.",
      "Construct neural networks using PyTorch or TensorFlow for item classification.",
      "Program Retrieval Augmented Generation (RAG) loops querying vector libraries."
    ],
    technologies: [
      { name: "Python Core", category: "Core Language", desc: "Sought-after scientific language with rich AI syntax", icon: "Terminal" },
      { name: "TensorFlow", category: "ML Platform", desc: "End-to-end framework for neural networks and graphs", icon: "Cpu" },
      { name: "PyTorch", category: "AI Framework", desc: "Scientific deep learning engine loved by search labs", icon: "Layers" },
      { name: "LangChain", category: "Generative AI", desc: "Seamless agentic orchestration framework for large language models", icon: "Activity" },
      { name: "Scikit-Learn", category: "Machine Learning", desc: "Robust toolset for classic regression and clustering models", icon: "Database" },
      { name: "Hugging Face", category: "NLP Suite", desc: "Host platform for pre-trained models and semantic tokens", icon: "Globe" }
    ],
    projects: [
      {
        title: "Generative Semantic Document Examiner",
        desc: "An advanced RAG-powered application allowing corporate users to upload dense files, query content, and extract structural citations with vector embeddings.",
        tech: ["Python", "LangChain", "OpenAI API", "ChromaDB"],
        application: "Legal teams reviewing massive bundles of active project agreements",
        difficulty: "Advanced"
      },
      {
        title: "Autonomous Anomaly Detection Pipeline",
        desc: "An online scanner which flags suspicious banking operations, optimizes neural thresholding levels, and alerts audit staff to card fraud.",
        tech: ["Scikit-learn", "Pandas", "PyTorch", "Flask"],
        application: "FinTech companies protecting accounts against cyber intrusions",
        difficulty: "Intermediate"
      }
    ],
    faqs: [
      {
        question: "Is high-level mathematics a mandatory prerequisite for this AI internship?",
        answer: "Fundamental understanding of linear algebra, calculus, and basic statistics will accelerate your learning, but we cover the mathematical formulas conceptually before building code."
      },
      {
        question: "Do students get access to computing resources for training intensive models?",
        answer: "Yes, we teach how to efficiently use cloud environments (Google Colab Pro, Kaggle setups, and Cloud VMs) for GPU-driven model training."
      }
    ]
  },
  {
    id: "data-science",
    shortSlug: "data-science",
    title: "Data Science",
    subTitle: "Big Data Processing, Statistical Analytics & Interactive Visualizations",
    heroHeadline: "Convert Raw Corporate Raw Datasets into Strategic Insights as a",
    heroHighlight: "Professional Data Scientist",
    heroParagraph: "Uncover insights buried under millions of records. Master statistical testing, interactive dashboards, advanced predictive models and modern data visualization techniques to back corporate decisions.",
    duration: "10 to 20 Weeks",
    availability: "Onsite/Hybrid",
    heroImage: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1200&q=80",
    stats: {
      studentsTrained: "8,500+",
      projectsCompleted: "600+",
      placementRate: "96.1%"
    },
    seoKeywords: [
      "Data science internship",
      "SQL analytics program",
      "Power BI training course",
      "Data visualizer internship",
      "Pandas Python analytics certification",
      "Business intelligence internship",
      "data science internship Tamil Nadu",
      "data analytics course Madurai",
      "online data science training for students",
      "internship for CSE IT students Tamil Nadu",
      "business intelligence training Tamil Nadu"
    ],
    metaTitle: "Data Science Internship Tamil Nadu | Hitasoft Talent Lab Madurai",
    metaDescription: "Master Python analytics, data cleaning, exploratory visual plots, SQL, and interactive dashboards. Join Hitasoft to work with real enterprise datasets.",
    careerOpportunities: [
      "Data Analyst Expert",
      "Business Intelligence Specialist",
      "Clinical Data Statistician",
      "Decision Support Consultant",
      "Analytics Manager"
    ],
    outcomes: [
      "Query, transform, and join sophisticated datasets in high-load SQL engines.",
      "Clean and wrangle incomplete real-world files, handling outliers and missing values.",
      "Formulate interactive analytical dashboards with Power BI or Tableau to track KPIs.",
      "Perform A/B testing and apply robust statistical models to explain business success."
    ],
    technologies: [
      { name: "Python Pandas", category: "Data Manipulation", desc: "Unmatched matrix toolset for tabular transformations", icon: "Terminal" },
      { name: "SQL (BigQuery/Postgres)", category: "Structured Databases", desc: "Core foundation to group, aggregate, and pull from data lakes", icon: "Database" },
      { name: "Power BI / Tableau", category: "Business Intelligence", desc: "Corporate standard for visual reporting and live KPIs", icon: "Layers" },
      { name: "Seaborn / Plotly", category: "Custom Visuals", desc: "Libraries for stunning statistical plots and interactive matrices", icon: "Activity" },
      { name: "Jupyter Notebooks", category: "Research Workspace", desc: "Dynamic execution environment for tracking experimental code", icon: "Globe" },
      { name: "NumPy & SciPy", category: "Numerical Engines", desc: "Mathematical matrices and arrays for rapid vector arithmetic", icon: "Cpu" }
    ],
    projects: [
      {
        title: "Retail Predictive Lifetime Value Model",
        desc: "A statistical analytics project predicting user attrition (churn) and calculating future loyalty values based on cohort spending trends.",
        tech: ["Python", "Pandas", "Scikit-Learn", "Tableau"],
        application: "Marketing managers planning premium loyalty discounts for target buyer bases",
        difficulty: "Advanced"
      },
      {
        title: "Public Health Geospatial Data Plotter",
        desc: "An interactive geographic tracker mapping regional demographic stats, calculating disease distributions, and visualizing risk levels.",
        tech: ["Python", "Plotly Express", "Streamlit", "Postgres"],
        application: "Government panels organizing resource deployments to high-risk hospitals",
        difficulty: "Intermediate"
      }
    ],
    faqs: [
      {
        question: "How is this Data Science internship structured compared to standard ML?",
        answer: "This program focuses strictly on analytical extraction, corporate story-telling, predictive metrics, clean reporting, SQL optimization, and business intelligence, whereas ML leans heavily into designing mathematical algorithms."
      },
      {
        question: "Do we work with real-world databases or fabricated mock sheets?",
        answer: "We focus on sanitized actual data logs from retail channels, health hubs, and transport metrics to ensure you encounter real issues like noisy fields and corrupted records."
      }
    ]
  },
  {
    id: "android-dev",
    shortSlug: "android-dev",
    title: "Android App Development",
    subTitle: "Native Kotlin & Multi-Platform Flutter Apps",
    heroHeadline: "Craft Innovative High-Performance Mobile Experiences as an",
    heroHighlight: "Android Developer",
    heroParagraph: "Place your apps in the pockets of millions of global users. Master Kotlin, Jetpack Compose, state-of-the-art app patterns (MVVM), and hybrid engines like Flutter to deliver responsive tactile UIs.",
    duration: "12 to 20 Weeks",
    availability: "Onsite/Hybrid",
    heroImage: "https://images.unsplash.com/photo-1607252631355-89473de14723?auto=format&fit=crop&w=1200&q=80",
    stats: {
      studentsTrained: "8,900+",
      projectsCompleted: "590+",
      placementRate: "97.1%"
    },
    seoKeywords: [
      "Android internship Kotlin",
      "Flutter app development course",
      "Kotlin mobile developer internship",
      "Jetpack Compose UI training",
      "Play Store deployment guide",
      "Hitasoft Mobile App Lab",
      "android development course Tamil Nadu",
      "Kotlin Flutter internship Madurai",
      "mobile app development internship Tamil Nadu",
      "android internship for college students",
      "app development training certificate Tamil Nadu"
    ],
    metaTitle: "Android App Development Internship Tamil Nadu | Hitasoft Talent Lab Madurai",
    metaDescription: "Acquire hands-on Android development skills using Kotlin, Jetpack Compose, and Flutter. Deploy live applications to the Play Store and build portfolios.",
    careerOpportunities: [
      "Native Android Developer",
      "Flutter Mobile Engineer",
      "Mobile Solution Architect",
      "UI App Interaction Specialist",
      "Mobile Software Consultant"
    ],
    outcomes: [
      "Code complete reactive apps using Kotlin and native declarative Jetpack Compose UI.",
      "Build cross-platform applications with single-codebase Flutter framework.",
      "Connect client side apps to REST APIs, manage local databases via Room, and secure tokens.",
      "Package and distribute production APK/AAB builds to the Google Play Console."
    ],
    technologies: [
      { name: "Kotlin", category: "Core Mobile Language", desc: "Google approved elegant modern type-safe language", icon: "Terminal" },
      { name: "Jetpack Compose", category: "UI declarative engine", desc: "Modern Android UI toolkit accelerating gorgeous screens", icon: "Layers" },
      { name: "Flutter", category: "Cross-Platform Framework", desc: "High fidelity compilation engine by Google using Dart", icon: "Cpu" },
      { name: "Firebase Service Suite", category: "Cloud Database / Auth", desc: "Real-time sync storage, cloud storage, notifications and logins", icon: "Database" },
      { name: "Retrofit / Axios", category: "Network Pipelines", desc: "Elegant REST API mapping for secure mobile client calls", icon: "Activity" },
      { name: "Android SDK & Studio", category: "Development Studio", desc: "Core integrated layout suite to build and compile apps", icon: "Globe" }
    ],
    projects: [
      {
        title: "Secure Encrypted Instant Chat Engine",
        desc: "A fully real-time messaging tool supporting offline message saving, live contact search, push alerts via FCM, and modern chat layouts.",
        tech: ["Kotlin", "Jetpack Compose", "Room Database", "Firebase Auth"],
        application: "Private organizations looking for modern secured chat interfaces",
        difficulty: "Advanced"
      },
      {
        title: "City Ride-Hailing Tracker Mockup",
        desc: "A multi-screen utility utilizing maps platforms, live GPS positioning, estimated arrival timetables, and interactive vehicle mock markers.",
        tech: ["Flutter", "Dart", "Google Maps SDK", "Retrofit"],
        application: "On-demand dispatch platforms moving cargo or commuters",
        difficulty: "Intermediate"
      }
    ],
    faqs: [
      {
        question: "Do I need an extremely high-spec computer to run Android Studio?",
        answer: "We recommend at least 8GB RAM and an SSD. If your local computer has lower specifications, we will guide you in deploying tests on physical devices or utilizing light, highly reactive Flutter environments."
      },
      {
        question: "Can I publish the final project to my personal Google Play Store account?",
        answer: "Indeed, our industry mentors assist you from compilation, setting asset ratios, preparing store screenshots up to passing automated checklist constraints."
      }
    ]
  },
  {
    id: "ios-dev",
    shortSlug: "ios-dev",
    title: "iOS App Development",
    subTitle: "Swift & SwiftUI Premium Apple App Architecture",
    heroHeadline: "Build Beautiful, Fluid, High-Performance Mobile Experiences as an",
    heroHighlight: "iOS Developer",
    heroParagraph: "Deliver pixel-perfect applications for the premium iOS ecosystem. Build responsive swipe interactions using Swift and SwiftUI, integrate ARKit structures, and master App Store deploy pipelines.",
    duration: "10 to 18 Weeks",
    availability: "Onsite/Hybrid",
    heroImage: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1200&q=80",
    stats: {
      studentsTrained: "4,200+",
      projectsCompleted: "310+",
      placementRate: "96.8%"
    },
    seoKeywords: [
      "iOS Developer internship Swift",
      "SwiftUI internship program",
      "Apple native developer training",
      "Xcode UI development course",
      "App Store deployment help",
      "Hitasoft iOS Engineering Lab",
      "iOS internship Tamil Nadu",
      "Swift mobile development course Madurai",
      "iOS app development training for students",
      "mobile app internship Tamil Nadu"
    ],
    metaTitle: "iOS App Development Internship Tamil Nadu | Hitasoft Talent Lab Madurai",
    metaDescription: "Master SwiftUI, Swift 5, Apple SDK frameworks, and Xcode. Learn premium application architecture and submit real projects to the Apple App Store.",
    careerOpportunities: [
      "Native iOS Developer",
      "Swift Software Engineer",
      "Apple Ecosystem Consultant",
      "Mobile Interface Interactionist",
      "Swift UI Architect"
    ],
    outcomes: [
      "Construct premium layout architectures using SwiftUI declarative designs.",
      "Work with CoreData and SwiftData for low latency offline device databases.",
      "Integrate Apple specific sensors like CoreLocation and gyroscope features.",
      "Diagnose and solve thread locks using modern async/await Swift principles."
    ],
    technologies: [
      { name: "Swift 5.x", category: "Core iOS Language", desc: "Superfast native language designed exclusively for Apple gear", icon: "Terminal" },
      { name: "SwiftUI", category: "Declarative UI Framework", desc: "Seamless code layout compiler giving responsive fluid sheets", icon: "Layers" },
      { name: "Xcode", category: "Development Interface", desc: "Core IDE with visual preview canvases and optimizer logs", icon: "Globe" },
      { name: "SwiftData / CoreData", category: "Local Core Storage", desc: "Direct device database engines for rapid secure retrieval", icon: "Database" },
      { name: "CocoaPods / Swift Package Manager", category: "Dependency Managers", desc: "Libraries pipeline keeping standard open packages integrated", icon: "Cpu" },
      { name: "CoreAnimation & Haptics", category: "Sensory Engagement", desc: "Rich custom gestures and precise subtle force feedback", icon: "Activity" }
    ],
    projects: [
      {
        title: "ZenFit Interactive Workout Companion",
        desc: "A stunning Health-App connected utility with custom workout circles, sleep duration graphs, and native dynamic widgets for the iOS home screen.",
        tech: ["SwiftUI", "HealthKit", "SwiftData", "CoreAnimation"],
        application: "Personal fitness platforms hoping to optimize mobile user retention",
        difficulty: "Advanced"
      },
      {
        title: "Splendido Gourmet Meal Finder",
        desc: "A location-aware food locator and table organizer showing top culinary hotspots with real-time driving vectors and review carousels.",
        tech: ["Swift", "SwiftUI", "MapKit", "CoreLocation"],
        application: "Tourism boards providing dynamic guides for premium local dining",
        difficulty: "Intermediate"
      }
    ],
    faqs: [
      {
        question: "Is having a macOS computer mandatory for this iOS program?",
        answer: "To run Xcode natively, a Mac runs best. However, if you are planning to learn cross-platform Flutter on Windows/Linux, we can provide remote Mac OS cloud sandbox servers to build your iOS project files."
      },
      {
        question: "Will I learn about dark mode setup and iOS widget additions?",
        answer: "Yes, Apple's design principles, responsive dark-mode palettes, safe area layouts, and system-level lock screen widgets are fully integrated in this curriculum."
      }
    ]
  },
  {
    id: "devops-engineer",
    shortSlug: "devops",
    title: "DevOps Engineer",
    subTitle: "CI/CD Automations, Kubernetes, Cloud (AWS / GCP) & Infrastructure as Code",
    heroHeadline: "Manage Auto-Scaling Production Cloud Engines as an",
    heroHighlight: "Infrastructure & DevOps Engineer",
    heroParagraph: "Deliver high availability. Automate manual software release pipelines, control high-scale container pods, and build robust Infrastructure as Code (IaC) templates running on AWS.",
    duration: "12 to 24 Weeks",
    availability: "Onsite/Hybrid",
    heroImage: "https://images.unsplash.com/photo-1618401471353-b98aedd07871?auto=format&fit=crop&w=1200&q=80",
    stats: {
      studentsTrained: "5,300+",
      projectsCompleted: "380+",
      placementRate: "98.5%"
    },
    seoKeywords: [
      "DevOps internship program",
      "Docker Kubernetes course with certificate",
      "AWS Cloud developer training",
      "Infrastructure as Code Terraform",
      "CI/CD automation pipelines",
      "Cloud systems engineer internship",
      "devops course Tamil Nadu",
      "cloud internship with certificate Tamil Nadu",
      "AWS DevOps training Madurai",
      "internship for engineering students devops",
      "cloud computing internship Tamil Nadu"
    ],
    metaTitle: "Cloud DevOps Engineering Internship Tamil Nadu | Hitasoft Talent Lab Madurai",
    metaDescription: "Master AWS Web services, Docker Containers, Kubernetes clusters, Jenkins pipeline automations, and infrastructure templates. Certified DevOps program.",
    careerOpportunities: [
      "DevOps Solutions architect",
      "Site Reliability Engineer (SRE)",
      "Cloud Infrastructure Developer",
      "Build & Release Automations Lead",
      "System Administrator Associate"
    ],
    outcomes: [
      "Formulate custom Docker images minimizing resource and footprint levels.",
      "Orchestrate auto-scaling production microservices layouts in Kubernetes clusters.",
      "Provision reliable multi-zone VPC networks on AWS using Terraform files.",
      "Configure fast automated GitHub Actions workflows running unit-tests and pushes."
    ],
    technologies: [
      { name: "Docker", category: "Container Engine", desc: "Packs app code and frameworks into consistent standalone targets", icon: "Cpu" },
      { name: "Kubernetes (K8s)", category: "Cluster Management", desc: "Automates container provisioning, health, scaling, and networks", icon: "Layers" },
      { name: "Amazon Web Services (AWS)", category: "Cloud Hosting Provider", desc: "Global server grids, database systems, and DNS gateways", icon: "Globe" },
      { name: "Terraform", category: "Infrastructure as Code", desc: "Deploys repeatable physical hardware configurations with configuration code", icon: "Database" },
      { name: "GitHub Actions", category: "CI/CD Automations", desc: "Continuous code validation, test runner, and target server deployer", icon: "Activity" },
      { name: "Nginx & Linux Basics", category: "Web Servers", desc: "High efficiency traffic router, reverse proxy, and Linux terminal utilities", icon: "Terminal" }
    ],
    projects: [
      {
        title: "Multi-Zone Resilient Cloud Architecture",
        desc: "A secure VPC configuration setting up independent load balancers, auto-healing cluster pods, and central log files for traffic alerts.",
        tech: ["AWS (EC2/EKS)", "Terraform", "Docker", "Kubernetes"],
        application: "High-scale SaaS solutions demanding 99.99% uptime guarantees",
        difficulty: "Advanced"
      },
      {
        title: "Continuous Deploy Web-App Pipeline",
        desc: "Strict automate pipeline compiling incoming React updates, running formatting tests, building target files, and deploying updates silently.",
        tech: ["GitHub Actions", "Docker", "Nginx", "Linux Scripting"],
        application: "Fast agile groups deploying code changes multiple times daily",
        difficulty: "Intermediate"
      }
    ],
    faqs: [
      {
        question: "Is DevOps suitable for someone with no coding background?",
        answer: "Basic scripting skills (such as Bash, YAML, or basic Node/Python syntax) are needed. Our roadmap first introduces essential Linux terminal controls to prepare you safely."
      },
      {
        question: "Do we work with expensive AWS cloud servers during class?",
        answer: "We leverage official AWS Free Tier tiers. You will be instructed in configuring auto-stop controls to ensure you never incur any unexpected billing expenses."
      }
    ]
  },
  {
    id: "qa-analyst",
    shortSlug: "qa",
    title: "QA Analyst",
    subTitle: "Automated Testing, Cypress, Selenium & Quality Performance Controls",
    heroHeadline: "Ensure Flawless User-Experience and Safe Code Releases as a",
    heroHighlight: "Quality Assurance Expert",
    heroParagraph: "Protect clients from buggy software. Learn professional manual auditing techniques, write advanced automated browser testing scripts, and run rigorous regression diagnostics.",
    duration: "8 to 16 Weeks",
    availability: "Onsite/Hybrid",
    heroImage: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1200&q=80",
    stats: {
      studentsTrained: "6,700+",
      projectsCompleted: "450+",
      placementRate: "94.8%"
    },
    seoKeywords: [
      "QA analyst internship",
      "Software automated testing training",
      "Cypress QA web suite certification",
      "Selenium automation python developer",
      "Manual test case writer",
      "Software testing internship with certificate",
      "QA testing internship Tamil Nadu",
      "software testing course Madurai",
      "automation testing training for students Tamil Nadu",
      "QA analyst internship with certificate Tamil Nadu"
    ],
    metaTitle: "Software QA Analyst & Automation Internship Tamil Nadu | Hitasoft Talent Lab",
    metaDescription: "Master Cypress, Selenium, Jest, JIRA, and manual test strategies. Write complete automated test scripts and excel as a professional QA analyst with Hitasoft.",
    careerOpportunities: [
      "QA Automation Engineer",
      "Manual Software Tester",
      "Performance Diagnostics Lead",
      "Product Acceptance Analyst",
      "Security Verification Consultant"
    ],
    outcomes: [
      "Document exhaustive manual test scenarios and outline clear trace logs.",
      "Program resilient end-to-end user path tests utilizing modern Cypress code.",
      "Implement multi-browser automation tests using Selenium and Python.",
      "Analyze network latency, request responses, and load stress parameters."
    ],
    technologies: [
      { name: "Cypress", category: "E2E Web Automation", desc: "Next-gen browser automation framework built on JS", icon: "Layers" },
      { name: "Selenium WebDriver", category: "Cross-browser test engine", desc: "Legacy robust standard mapping commands directly to browsers", icon: "Cpu" },
      { name: "JIRA", category: "Defect Tracking Board", desc: "Enterprise standard for cataloging bugs, tasks and sprint targets", icon: "Database" },
      { name: "Jest", category: "Unit Testing Utility", desc: "Fast JS evaluation environment with mock frameworks", icon: "Terminal" },
      { name: "Postman", category: "API Assertion Suite", desc: "Interface used to query, check, and load-test backend REST APIs", icon: "Globe" },
      { name: "Apache JMeter", category: "Stress Testing Tool", desc: "Simulates thousands of virtual traffic users to stress-test backends", icon: "Activity" }
    ],
    projects: [
      {
        title: "Comprehensive E-Commerce Testing Suite",
        desc: "An advanced automation layout mimicking buyers adding inventory items, filling discount coupons, and submitting mock payments, checking for any screen glitches.",
        tech: ["Cypress", "Postman API Testing", "Jest", "GitHub Actions"],
        application: "Online retailers making daily web additions with zero site downtime",
        difficulty: "Advanced"
      },
      {
        title: "Load Stress Evaluation Profile",
        desc: "An intensive diagnostic report checking response bottlenecks when hitting APIs with high concurrent payload requests.",
        tech: ["Apache JMeter", "Postman", "Linux Logs"],
        application: "Government application systems handling quick citizen applications",
        difficulty: "Intermediate"
      }
    ],
    faqs: [
      {
        question: "Is coding secondary in this Quality Assurance internship?",
        answer: "We train you in both Manual Testing (excellent for logical analysis and rapid starts) and Automation Testing (essential for high-salary modern DevOps pipelines using Cypress/JS)."
      },
      {
        question: "Do you teach bug reporting standards?",
        answer: "Yes, you will learn to structure professional tickets in JIRA, attach diagnostic payloads, frame precise steps to reproduce, and define severity parameters."
      }
    ]
  },
  {
    id: "marketing-sales-hr",
    shortSlug: "marketing",
    title: "Digital Marketing | Sales | HR",
    subTitle: "Modern SEO, Corporate Communications & Strategic Recruitment",
    heroHeadline: "Accelerate Customer Acquisition & Talent Acquisitions as a",
    heroHighlight: "Business & Growth Strategist",
    heroParagraph: "Go beyond lines of code. Gain actual competencies in web search optimizations (SEO), build viral advertising campaigns on Meta, and master modern ATS systems to land top talents.",
    duration: "8 to 12 Weeks",
    availability: "Onsite/Hybrid",
    heroImage: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80",
    stats: {
      studentsTrained: "10,200+",
      projectsCompleted: "720+",
      placementRate: "94.2%"
    },
    seoKeywords: [
      "Digital marketing internship",
      "SEO search optimization training",
      "Social media marketing course",
      "HR recruiter training program",
      "Sales development representative internship",
      "Hitasoft business management training",
      "digital marketing internship Tamil Nadu",
      "HR internship Madurai",
      "HR internship Tamil Nadu",
      "digital marketing course Tamil Nadu students",
      "sales training internship Tamil Nadu",
      "marketing internship with certificate Tamil Nadu"
    ],
    metaTitle: "Digital Marketing, Sales & HR Internship Tamil Nadu | Hitasoft Talent Lab Madurai",
    metaDescription: "Develop your corporate career. Master Google Analytics, SEO techniques, LinkedIn recruitment, and brand structures. Industry verified internship.",
    careerOpportunities: [
      "SEO Growth Strategist",
      "Social Media Campaigner",
      "Talent Acquisition Associate (HR)",
      "Business Development Executive",
      "Corporate Brand Manager"
    ],
    outcomes: [
      "Perform expert keyword research and construct SEO ranking layouts.",
      "Configure Google Search Console and target Facebook/Google advertising metrics.",
      "Conduct phone screens and organize candidate pipelines using ATS products.",
      "Draft pitch decks and run email automation funnels with crisp copy."
    ],
    technologies: [
      { name: "Google Analytics 4", category: "Audit & Analysis Suite", desc: "Core platform mapping client traffic, bounce levels, and goals", icon: "Activity" },
      { name: "SEMrush / Ahrefs", category: "SEO research systems", desc: "Key tracker monitoring keyword difficulty, competitor rankings", icon: "Database" },
      { name: "HubSpot CRM", category: "Sales Enablement", desc: "Client organization dashboard and email interaction tracker", icon: "Layers" },
      { name: "LinkedIn Recruiter", category: "HR Acquisition Tool", desc: "Sourcing platform to find, engage, and recruit top candidates", icon: "Globe" },
      { name: "Meta Ads Manager", category: "Strategic Campaigns", desc: "Pinnacle tool structuring visual ads targeting niche demographics", icon: "Cpu" },
      { name: "Mailchimp", category: "Communications Automator", desc: "Platform to build automated sequence newsletters with layout templates", icon: "Terminal" }
    ],
    projects: [
      {
        title: "Organic SaaS Inbound Growth Campaign",
        desc: "A meticulous SEO restructuring study which boosted a local web portal's organic monthly visits by targeting long-tail searches.",
        tech: ["SEMrush", "Google Analytics 4", "WordPress SEO Plugins"],
        application: "Startup products hoping to reduce expensive AdWords expenditure",
        difficulty: "Advanced"
      },
      {
        title: "Mock Technical Recruiting Hackathon",
        desc: "A hands-on HR assignment mapping candidate pipelines, designing phone screens, and conducting interviews for programmer positions.",
        tech: ["LinkedIn Recruiter", "Trello ATS Mockup", "Google Workspace"],
        application: "Fast-scaling team units hiring thirty new staff quarterly",
        difficulty: "Intermediate"
      }
    ],
    faqs: [
      {
        question: "Can I choose to specialize ONLY in Digital Marketing or strictly inside HR?",
        answer: "Absolutely. When joining, you elect either the Marketing-Sales track (ideal for metrics & copy lovers) or the HR Recruitment track (amazing for organizers & networkers)."
      },
      {
        question: "What real business experience do we gain on Google ranking?",
        answer: "We help you optimize actual site structures under strict web guidelines, teaching keyword placement, metadata updates, and search console checks."
      }
    ]
  },
  {
    id: "ui-ux-design",
    shortSlug: "ui-ux",
    title: "UI/UX Design",
    subTitle: "Digital Product Prototyping, Wireframing & User Research",
    heroHeadline: "Craft Premium, Goal-Driven, and Fluid Screen Experiences as a",
    heroHighlight: "UI/UX Product Designer",
    heroParagraph: "Design gorgeous, meaningful products. Master the psychology of visual hierarchy, learn to construct complete components libraries in Figma, and build functional application prototypes.",
    duration: "8 to 16 Weeks",
    availability: "Onsite/Hybrid",
    heroImage: "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?auto=format&fit=crop&w=1200&q=80",
    stats: {
      studentsTrained: "6,900+",
      projectsCompleted: "485+",
      placementRate: "96.5%"
    },
    seoKeywords: [
      "UI UX design internship",
      "Figma prototyping course",
      "User research training certificate",
      "Mobile wireframe design program",
      "Web interface design layout",
      "Hitasoft Creative Design Lab",
      "UI UX internship Tamil Nadu",
      "Figma design course Madurai",
      "product design internship Tamil Nadu students",
      "UI design training with certificate Tamil Nadu",
      "UX research internship for engineering students"
    ],
    metaTitle: "UI/UX Product Design Internship Tamil Nadu | Hitasoft Talent Lab Madurai",
    metaDescription: "Master Figma, interactive wireframes, typography pairings, color rules, and testing strategies. Build a world-class creative design portfolio.",
    careerOpportunities: [
      "Product UI/UX Designer",
      "User Research Consultant",
      "Interaction wireframe Analyst",
      "Visual Interface Developer",
      "Design Systems Specialist"
    ],
    outcomes: [
      "Translate raw user interviews into comprehensive, clear persona worksheets.",
      "Organize low fidelity wireframes quickly mapping fundamental item priorities.",
      "Construct beautiful Design Systems in Figma with responsive component variables.",
      "Establish fluid, clickable, micro-animated interactive client demonstrations."
    ],
    technologies: [
      { name: "Figma", category: "Collab Design UI", desc: "The supreme tool for creating wireframes, vectors and animations", icon: "Layers" },
      { name: "Adobe XD", category: "Prototyping software", desc: "Interactive builder optimized for desktop layouts", icon: "Globe" },
      { name: "Miro", category: "Dynamic Whiteboard", desc: "Workspace for user mapping, workflows and card sorting studies", icon: "Database" },
      { name: "Prototyping Vectors", category: "Animation framework", desc: "Flow connections showing sliding pages and overlay sheets", icon: "Activity" },
      { name: "UI Colors & Typography", category: "Core Design Theory", desc: "Scientific rules mapping readability, contrast, and branding vibes", icon: "Terminal" },
      { name: "User Testing Loops", category: "Verification Protocol", desc: "Review procedures testing if participants easily navigate key actions", icon: "Cpu" }
    ],
    projects: [
      {
        title: "Fintech Mobile Wallet Interface",
        desc: "A beautiful, premium, dark-themed layout prioritizing quick security clicks, custom investment trends, and simplified multi-currency transfers.",
        tech: ["Figma", "Design Systems", "Prototyping Vectors"],
        application: "High-level visual solutions for safe digital banking products",
        difficulty: "Advanced"
      },
      {
        title: "EcoHarvest Food Delivery Wireframes",
        desc: "An eco-friendly grocery service tracking deliveries, showcasing local organic vegetables, and organizing order tracking charts.",
        tech: ["Figma", "Miro User Research", "Adobe XD"],
        application: "Local hyper-delivery systems targeting busy healthy families",
        difficulty: "Intermediate"
      }
    ],
    faqs: [
      {
        question: "Do I need drawing skills or artistic talent to be a UI/UX Designer?",
        answer: "No, UI/UX is built on structured architectural guidelines: layout contrast, grid systems, alignment, and empathetic student research rather than freehand landscape illustration."
      },
      {
        question: "Will this program teach me how to build coding scripts?",
        answer: "Coding is not part of this core lane. However, we teach design-to-developer handoff protocols to help you prepare CSS assets that match web code needs."
      }
    ]
  }
];
